<h1><a href="/home">Login</a> - Forgot Password</h1>

<section id="forgot-password">
    <p>Enter your username and your account's email address.
        We will send a temporary password to the email entered.</p>

    <p class="errormsg">{{errormsg}}</p>
    <p class="msg">{{msg}}</p>

    <p><label>User Name: * </label><input type="text" class="input" autocomplete="off" required id="username" [(ngModel)]="username"></p>
    <p><label>Email Address: * </label>
        <input type="email" class="input" autocomplete="off" required email #emailCtrl="ngModel" name="email" [(ngModel)]="email" />
        @if(emailCtrl.invalid && emailCtrl.touched) {            
            @if(emailCtrl.errors?.['required']) {
                <small> Email is required.</small>
            }
            @if(emailCtrl.errors?.['email']) {
                <small> Invalid email format.</small>
            }            
        }
    </p>
    <p>* denotes a required field.</p>
    <p><button [disabled]="!username || emailCtrl.invalid" (click)="resetPassword()">Reset Password</button></p>
</section>